import React from "react";
import { useWindowSize } from "@overrides_venia/peregrine/hooks/useWindowSize";

//Utils
import { useIntl } from "react-intl";

//Assets
import bg_contatore_d from "@Assets/images/area-personale/sfondi/contatore-d.png";
import bg_contatore_1_d from "@Assets/images/area-personale/sfondi/contatore-1-d.png";
import bg_contatore_m from "@Assets/images/area-personale/sfondi/contatore-m.png";
import bg_contatore_1_m from "@Assets/images/area-personale/sfondi/contatore-1-m.png";
import bg_credito_5_d from "@Assets/images/area-personale/sfondi/credito-5-d.png";
import bg_credito_5_m from "@Assets/images/area-personale/sfondi/credito-5-m.png";
import bg_credito_10_d from "@Assets/images/area-personale/sfondi/credito-10-d.png";
import bg_credito_10_m from "@Assets/images/area-personale/sfondi/credito-10-m.png";
import bg_credito_15_d from "@Assets/images/area-personale/sfondi/credito-15-d.png";
import bg_credito_15_m from "@Assets/images/area-personale/sfondi/credito-15-m.png";
import bg_credito_20_d from "@Assets/images/area-personale/sfondi/credito-20-d.png";
import bg_credito_20_m from "@Assets/images/area-personale/sfondi/credito-20-m.png";
import bg_credito_25_d from "@Assets/images/area-personale/sfondi/credito-25-d.png";
import bg_credito_25_m from "@Assets/images/area-personale/sfondi/credito-25-m.png";
function getMoneyEarned(totalPoints) {
  switch (true) {
    case totalPoints < 1000:
      return 5;
    case totalPoints < 1500:
      return 10;
    case totalPoints < 2000:
      return 15;
    case totalPoints < 2500:
      return 20;
    case totalPoints >= 2500:
      return 25;
    default:
      return 0;
  }
}
export function getRange(totalPoints) {
  switch (true) {
    case totalPoints < 1000:
      return 1000;
    case totalPoints < 1500:
      return 1500;
    case totalPoints < 2000:
      return 2000;
    case totalPoints < 2500:
      return 2500;
    default:
      return null;
  }
}
export function getBackgroundMobile(totalPoints) {
  switch (true) {
    case totalPoints >= 1 && totalPoints <= 499:
      return bg_contatore_1_m;
    case totalPoints < 500:
      return bg_contatore_m;
    case totalPoints < 1000:
      return bg_credito_5_m;
    case totalPoints < 1500:
      return bg_credito_10_m;
    case totalPoints < 2000:
      return bg_credito_15_m;
    case totalPoints < 2500:
      return bg_credito_20_m;
    case totalPoints >= 2500:
      return bg_credito_25_m;
    default:
      return bg_contatore_1_m;
  }
}
export function getBackgroundDesktop(totalPoints) {
  switch (true) {
    case totalPoints >= 1 && totalPoints <= 499:
      return bg_contatore_1_d;
    case totalPoints < 500:
      return bg_contatore_d;
    case totalPoints < 1000:
      return bg_credito_5_d;
    case totalPoints < 1500:
      return bg_credito_10_d;
    case totalPoints < 2000:
      return bg_credito_15_d;
    case totalPoints < 2500:
      return bg_credito_20_d;
    default:
      return bg_credito_25_d;
  }
}
export function getBackgroundColorFiller(totalPoint) {
  switch (true) {
    case totalPoint >= 1 && totalPoint <= 499:
      return "#4D6F68";
    case totalPoint < 500:
      return "#9A5946";
    case totalPoint < 1000:
      return "#C39D7E";
    case totalPoint < 2000:
      return "#9A5946";
    default:
      return "#4D6F68";
  }
}
export var MoneyBox = _ref => {
  var {
    totalPoints,
    classes,
    children
  } = _ref;
  var {
    isMobile
  } = useWindowSize();
  var {
    formatMessage
  } = useIntl();
  var box = /*#__PURE__*/React.createElement("div", {
    className: "money uk-flex ".concat(isMobile ? "uk-height-1-1" : "", " uk-flex-column uk-text-center uk-flex-right uk-padding-normal-bottom ").concat(classes.money)
  }, /*#__PURE__*/React.createElement("h2", null, getMoneyEarned(totalPoints), /*#__PURE__*/React.createElement("span", {
    className: "currency ".concat(classes.currency)
  }, formatMessage({
    id: "currency"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "money-label ".concat(classes.label)
  }, formatMessage({
    id: "loyalty.credit"
  })), children);
  return box;
};
export var SeedsBox = _ref2 => {
  var {
    totalPoints,
    classes,
    children
  } = _ref2;
  var {
    isMobile
  } = useWindowSize();
  var range_seeds = 500;
  var {
    formatMessage
  } = useIntl();
  var box = /*#__PURE__*/React.createElement("div", {
    className: "seeds uk-flex ".concat(isMobile ? "uk-height-1-1" : "", "  uk-flex-column uk-text-center uk-flex-right uk-padding-normal-bottom  ").concat(classes.seeds)
  }, /*#__PURE__*/React.createElement("div", {
    className: "step ".concat(classes.step)
  }, /*#__PURE__*/React.createElement("span", {
    className: "number ".concat(classes.number)
  }, totalPoints), /*#__PURE__*/React.createElement("span", {
    className: "number ".concat(classes.number)
  }, "/ ", range_seeds)), /*#__PURE__*/React.createElement("div", {
    className: "money-label ".concat(classes.label)
  }, formatMessage({
    id: "loyalty.seeds.title"
  })), /*#__PURE__*/React.createElement("div", {
    className: "money-info ".concat(classes.info)
  }, formatMessage({
    id: "loyalty.seeds.message1"
  }), range_seeds - totalPoints, formatMessage({
    id: "loyalty.seeds.message2"
  })), children);
  return box;
};